// extracted by mini-css-extract-plugin
module.exports = {"hours":"OpeningTimesTable_hours__cRQDO","exception":"OpeningTimesTable_exception__RsDsj"};